/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Train_Chip_RestInputs */

const en_features_train_chip_rest = /** @type {(inputs: Features_Train_Chip_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rest counts itself down`)
};

const pl_features_train_chip_rest = /** @type {(inputs: Features_Train_Chip_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przerwa odlicza się sama`)
};

/**
* | output |
* | --- |
* | "Rest counts itself down" |
*
* @param {Features_Train_Chip_RestInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_train_chip_rest = /** @type {((inputs?: Features_Train_Chip_RestInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Train_Chip_RestInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_train_chip_rest(inputs)
	return en_features_train_chip_rest(inputs)
});